import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Containers/StaticSearch/StaticSearch';
import { fetchMostGifted } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'MostGifted.title',
    defaultMessage: 'Most Gifted',
  },
  fullTitle: {
    id: 'MostGifted.seotitle',
    defaultMessage: 'Most Gifted Favorites | Top PC Games, eBooks & Software at Best Prices',
  },
  desc: {
    id: 'MostGifted.seodesc',
    defaultMessage: 'Experience the joy of giving! Explore the top PC and Steam games, eBooks, and software most gifted by our community. Find perfect digital presents today',
  },
  pcGameDeals: {
    id: 'MostGifted.pcgamedeals',
    defaultMessage: 'PC Game Deals',
  },
});

export default function TrendingDeals() {
  const { formatMessage } = useIntl();

  const crumbs = [{
    label: formatMessage(messages.pcGameDeals),
    link: '/on-sale/',
  },
  {
    label: formatMessage(messages.title),
    link: '/most-gifted',
  },
  ];

  return (<StaticSearch
    updateHits={fetchMostGifted}
    url="most-gifted"
    seoBlurb={messages.desc}
    crumbs={crumbs}
    {...messages}
  />);
}
